import React from "react";

const Bread = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 8.579"
    >
      <path
        id="fast-food"
        d="M16.053,17.742a1.159,1.159,0,0,1-.053.421,1.319,1.319,0,0,1-.211.368.848.848,0,0,1-.368.211.992.992,0,0,1-.421.105,1.239,1.239,0,0,1-.421-.105c-.105-.053-.263-.158-.368-.211A.848.848,0,0,1,14,18.163a1.026,1.026,0,0,1-.053-.421V16.163a.282.282,0,0,0-.263-.263,16.017,16.017,0,0,0-2.842.474.35.35,0,0,0-.211.263v1.105a1.159,1.159,0,0,1-.053.421,1.319,1.319,0,0,1-.211.368.848.848,0,0,1-.368.211.992.992,0,0,1-.421.105,1.239,1.239,0,0,1-.421-.105c-.105-.053-.263-.158-.368-.211a.848.848,0,0,1-.211-.368,4.081,4.081,0,0,1-.053-.474.236.236,0,0,0-.368-.211C6.158,18.584,5,20.111,5,21.742A3.183,3.183,0,0,0,5.211,22.9a2.391,2.391,0,0,0,2.263,1.579H22.526A2.391,2.391,0,0,0,24.789,22.9,4.106,4.106,0,0,0,25,21.742c0-1.632-1.158-3.158-3.158-4.263a.236.236,0,0,0-.368.211,4.081,4.081,0,0,1-.053.474,1.319,1.319,0,0,1-.211.368.848.848,0,0,1-.368.211.992.992,0,0,1-.421.105A1.239,1.239,0,0,1,20,18.742c-.105-.053-.263-.158-.368-.211a.848.848,0,0,1-.211-.368,1.026,1.026,0,0,1-.053-.421V16.637a.35.35,0,0,0-.211-.263,12.339,12.339,0,0,0-2.842-.474.249.249,0,0,0-.263.263v1.579Z"
        transform="translate(-5 -15.9)"
        fill={color}
      />
    </svg>
  );
};

export default Bread;
